import { z } from 'zod';

const SeedingDeliveryAddressItemSchema = z
  .object({
    /** 배송지 ID (수락/신청 API 의 deliveryAddressId) */
    id: z.number().int(),
    addressName: z.string().nullable(),
    isPrimary: z.boolean(),
    name: z.string(),
    phone: z.string(),
    zipcode: z.string(),
    address1: z.string(),
    address2: z.string().nullable(),
    memo: z.string().nullable(),
  })
  .describe('SeedingDeliveryAddressItem');

export type SeedingDeliveryAddressItem = z.infer<typeof SeedingDeliveryAddressItemSchema>;

export const GetSeedingDeliveryAddressesServiceResponseSchema = z
  .object({
    addresses: z.array(SeedingDeliveryAddressItemSchema),
  })
  .describe('GetSeedingDeliveryAddressesServiceResponseSchema');

export type GetSeedingDeliveryAddressesServiceResponse = z.infer<
  typeof GetSeedingDeliveryAddressesServiceResponseSchema
>;
